import React from "react";
import "../styles/AdminPractitionerSlotGrid.css";
import { useTranslation } from "react-i18next";

const AdminPractitionerSlotGrid = ({ date, slotData, onSlotSelect, selectedSlotInfo, isLoading, discipline }) => {
  const { t } = useTranslation();

  if (isLoading) {
    return <div className="loading-spinner_v3">{t("admin_sched.loading_slots")}</div>;
  }

  if (!slotData || slotData.length === 0) {
    return (
      <div className="no-pracs-message_v3">
        {t("admin_sched.no_appointments_for_date")}
      </div>
    );
  }

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
    });
  };

  const getGenderLabel = (genderCode) => {
    if (genderCode === "M") return t("admin_sched.gender_male");
    if (genderCode === "F") return t("admin_sched.gender_female");
    return "";
  };


  return (
    <div className="prac-list-wrapper_v3">
      {slotData.map((practitioner) => {
        const {
          practitioner_id,
          practitioner_first_name,
          practitioner_last_name,
          practitioner_display_name,
          practitioner_is_registered,
          practitioner_gender,
          practitioner_skills,
        } = practitioner;

        const displayName =
          practitioner_display_name ||
          `${practitioner_first_name} ${practitioner_last_name}`;

        const stationKeys = Object.keys(practitioner).filter((key) =>
          key.startsWith("appointments")
        );

        const hasAtLeastOneSlot = stationKeys.some(
          (key) => practitioner[key] && practitioner[key].length > 0
        );

        if (!hasAtLeastOneSlot) return null;

        let baseFee = "—";
        for (let key of stationKeys) {
          const slots = practitioner[key];
          if (slots?.length > 0) {
            const rawFee = slots[0]?.practitioner?.base_fee;
            if (rawFee !== undefined && rawFee !== null) {
              baseFee = parseFloat(rawFee).toFixed(2);
            }
            break;
          }
        }

        return (
          <div key={practitioner_id} className="prac-card-full_v3">
            <div className="prac-header_v3">
              <div className="prac-name-group_v3">
                <p className="prac-name_v3">
                  {displayName}
                  {getGenderLabel(practitioner_gender) && (
                    <span className="gender-label_v3">
                      ({getGenderLabel(practitioner_gender)})
                    </span>
                  )}
                </p>
              </div>
              <div className="prac-badges_v3">
                {practitioner_is_registered ? (
                  <span className="badge_v3 licensed_v3">
                    {t("admin_sched.licensed_practitioner")}
                  </span>
                ) : (
                  <span className="badge_v3 not-licensed_v3">
                    {t("admin_sched.non_licensed_practitioner")}
                  </span>
                )}
                {/* <span className="badge_v3 fee-badge_v3">
                  {t("admin_sched.appointment_fee", { fee: baseFee })}
                </span> */}
                <span className="badge_v3 fee-badge_v3">
                  {t("admin_sched.appointment_fee", { fee: baseFee })}{" "}
                  {discipline !== "Acupuncture" && "(plus tax)"}
                </span>

              </div>
            </div>
            
            {practitioner_skills && (
                <div className="prac-skills-line_v3">
                  <p className="skills-title_v3"><strong>{t("admin_sched.skills")}:</strong></p>
                  <div className="skills-tags_v3">
                    {practitioner_skills.split(',').map((skill, index) => (
                      <span key={index} className="skill-tag_v3">{skill.trim()}</span>
                    ))}
                  </div>
                </div>
              )}
              
            {stationKeys.map((stationKey) => {
              const stationSlots = practitioner[stationKey] || [];
              if (stationSlots.length === 0) return null;

              return (
                <div key={stationKey} className="station-block_v3">
                  <div className="slot-flex-box_v3">
                    {stationSlots.map((slot, idx) => {
                      const isSelected =
                        selectedSlotInfo?.practitionerId === practitioner_id &&
                        selectedSlotInfo?.slot?.id === slot.id;

                      return (
                        <button
                          key={slot.id || idx}
                          className={`slot-btn_v3 ${isSelected ? "selected" : ""}`}
                          onClick={() =>
                            onSlotSelect({
                              practitionerId: practitioner_id,
                              practitionerName: displayName,
                              date,
                              slot,
                              endTime: formatTime(slot.end),
                            })
                          }
                        >
                          {formatTime(slot.start)} – {formatTime(slot.end)}
                        </button>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default AdminPractitionerSlotGrid;
